import React, { useEffect, useState, useCallback, forwardRef } from 'react';
import AddLivetag from '../components/add-livetag';
import { LiveService } from '../services/live-service';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import is from 'date-fns/esm/locale/is/index.js';

//Snackbar
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    borderRadius: '6px',
    border: '1px solid #fff',
    boxShadow: 24,
    p: 4,
};

export default function LivetagAutocomplete({ tags, isMultiple, newLabel, shrink, onUpdate, noClearable }) {

    const [options, setOptions] = useState([]);
    //value: le option selezionate
    const [value, setValue] = useState([]);
    //inputValue è il testo che viene scritto nel textfield
    const [inputValue, setInputValue] = useState('');
    //Mui Modal
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [state, setState] = useState({
        openSB: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: 'success',
        ahduration: 3000,
        instructions: ''
    });

    const { openSB, vertical, horizontal, message, severity, ahduration, instructions } = state;
    const Alert = forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const initializeTags = useCallback(async () => {
        if (tags !== null || tags !== undefined) {
            if (isMultiple) {
                /* tags = tags.map(option => {
                                const firstLetter = option.name[0].toUpperCase();
                                return {
                                    ...option,
                                    firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
                                };
                            }); */
                setOptions(tags);
                setValue(tags);
            }
            else {
                setOptions(tags);
                setValue(...tags);
            }
        }
    }, [tags, isMultiple])

    useEffect(() => {
        initializeTags();
        return () => {
            setOptions([]);
            setValue([]);
        };
    }, [initializeTags]);

    useEffect(() => {
        if (inputValue) {
            (async () => {
                let tagContain = await LiveService.getListTag(
                    {
                        name__icontains: inputValue
                    });
                if (tagContain.results != null) {
                    setOptions([...tagContain.results]);
                }
            })();
        }
    }, [inputValue]);

    function handleUpdateAddLiveTag(tag, wasAdded) {
        //console.log('Tag di ritorno da Add Livetag', tag);

        if (wasAdded === false) {
            //Se in errore
            setState({
                openSB: true,
                vertical: 'top',
                horizontal: 'center',
                message: 'Non è stato possibile salvare il nuovo tag!',
                severity: 'error',
                ahduration: null,
                instructions: null
            });
            return;
        }

        tags.push(tag);
        //initializeTags();
        onUpdate(tags);
        handleClose();

        if (wasAdded === true) {
            setState({
                openSB: true,
                vertical: 'top',
                horizontal: 'center',
                message: 'Salvato correttamente!',
                severity: 'success',
                ahduration: 2000,
                instructions: null
            })
        }
    }

    const handleCloseSnackbar = () => {
        setState({ ...state, openSB: false });
    };

    return (
        <>
            <div style={{ display: "flex", width: "100%" }}>
                {isMultiple ? <button type="button" className="btn btn-sm btn-primary active"
                    title="Ricarica i tags salvati"
                    style={{ margin: "0px 4px 0px 0px", maxHeight: "40px" }}
                    onClick={() => { initializeTags() }}>Reset</button> : ''}
                <Autocomplete
                    disableClearable={noClearable}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && isMultiple) {
                            // Prevent's default 'Enter' behavior.
                            event.defaultMuiPrevented = true;
                        }
                    }}
                    value={value || ''}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                        onUpdate(newValue);
                        //console.log('newValue: ', newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    multiple={isMultiple}
                    //limitTags={2}
                    id="livetags"
                    size="small"
                    sx={{ width: "100%" }}
                    options={options.sort((a, b) => -b.name[0].toUpperCase().localeCompare(a.name[0].toUpperCase()))}
                    //options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                    //groupBy={(option) => option?.name[0]?.toUpperCase() || ''}
                    groupBy={(function (option) {
                        return option.name !== undefined ? String(option?.name?.charAt(0).toUpperCase()) : '';
                    })}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    getOptionLabel={(function (option) {
                        return option.name !== undefined ? String(option?.name) : '';
                    })}
                    //defaultValue={[options[0].name]}
                    //freeSolo
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <div>
                                <span><FontAwesomeIcon icon={['fas', 'tag']} size={'1x'} color={'#0d6efd'} />   </span>
                                <span style={{ fontSize: "0.7rem" }}>{option?.name?.toUpperCase()}</span>
                            </div>
                        </li>
                    )}
                    noOptionsText={(
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            Tag not available
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handleOpen}
                            >
                                Add New Tag
                            </Button>
                        </Box>
                    )}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip variant="outlined" color="primary"
                                key={index}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })} />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={newLabel}
                            placeholder="Search"
                            InputLabelProps={{
                                shrink: shrink,
                            }}
                        />
                    )}
                />
                <Snackbar open={openSB} autoHideDuration={ahduration}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical, horizontal }}>
                    <Alert onClose={handleCloseSnackbar} severity={severity} sx={{ width: '100%' }}>
                        <div style={{ textAlign: "center" }}>{message}</div>
                        {instructions ?
                            <Alert severity="info" sx={{ margin: "10px 0 0 0" }}>
                                {instructions}
                            </Alert>
                            : ''}
                    </Alert>
                </Snackbar>
                <Modal
                    aria-labelledby="livetag-modal-title"
                    aria-describedby="livetag-modal-description"
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <Box sx={style}>
                            <Typography id="livetag-modal-title" variant="h6" component="h2">
                                New Tag
                            </Typography>
                            <AddLivetag onUpdate={handleUpdateAddLiveTag} />
                            <div style={{ textAlign: "center" }}>
                                <button type="button" className="btn btn-secondary"
                                    style={{ minWidth: '6rem', marginTop: '24px' }}
                                    onClick={handleClose}>
                                    Chiudi
                                </button>
                            </div>
                        </Box>
                    </Fade>
                </Modal>
            </div>
        </>
    );
}